export enum EdlTooltipIcon {
    HELP = "fas fa-circle-question",
    INFO = "fas fa-circle-info"
}